module.exports = __webpack_public_path__ + "media/images/testimonial1-b454b1900840beb78835d90868b2e97e.jpg";